import { api } from '../../lib/api'

export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILED = 'REGISTER_FAILED'
export const REGISTER_CLEAR = 'REGISTER_CLEAR'

export const register = function (username, email, password, passwordRepeat, onRegister) {
    return function dispatch(dispatch) {
        dispatch({
            type: REGISTER_REQUEST,
            username,
            email,
            password,
            passwordConfirmation: passwordRepeat
        })

        api.register(username, email, password, passwordRepeat).then(registerResponse => {
            dispatch({
                type: REGISTER_SUCCESS,
                payload: registerResponse
            })
            // attempt login after register 
            onRegister();
        }).catch(error => {
            dispatch({
                type: REGISTER_FAILED,
                error
            })
        })
    }
}

export const clearRegister = () => {
    return function dispatch(dispatch) {
        dispatch({
            type: REGISTER_CLEAR
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/register.js